import { connect } from 'react-redux';

import Permission from './Permission';

const mapStateToProps = state => {
  return {
    drawerTitle: state.rolesPermissions.drawerTitle,
  };
};

export default connect(mapStateToProps)(Permission);
